import { ICoordinate } from '../../coordinate.model';
import { IStation } from './station.model';
import { IVehicle } from './vehicle.model';

export enum MicromobilityLinkType {
  docklessVehicle,
  stationBound,
}

export interface IMicromobilityLink {
  id: string;
  type: MicromobilityLinkType;
  replacesLegIndex: number[];
  vehicle?: IVehicle | undefined;
  allAvailableVehicles?: IVehicle[] | undefined;
  allAvailableStations?: IStation[] | undefined;
  destination?: ICoordinate | undefined;
  originStation?: IStation | undefined;
  destinationStation?: IStation | undefined;
  plannedDepartureTime: string;
  plannedArrivalTime: string;
  plannedDurationInMinutes: number;
  linkCoordinates: ICoordinate[];
  distanceInMeters: number;
  fromSearchLocationName?: string | undefined;
  toSearchLocationName?: string | undefined;
}
